import React from 'react';
import styled from 'styled-components';

const FooterBar = styled.div`
    display: flex;
    flex-direction: row;
    padding-left: 212px;
    div{
        margin-left: auto;
        margin-right: auto;
        font-size: 14px;
        color: #A3A3B1;
    }
    margin: 0px 20px; 
    margin-bottom: 20px;
    @media (max-width: 900px){
        margin: auto; 
        padding: 0px 0px 20px 16px; 
    }

`;

export const Footer = () => (
    <FooterBar>
        <div>Copyright © 2020 Rutgers Cancer Institute of New Jersey and School of Communication and Information. All rights reserved.</div>
    </FooterBar>
)